// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1ZxbR","footer":"ChangeClinic_footer__3g4N8"};